import {type App, computed, ref} from "vue";
import api from '../api'
import {type DocReply, type User, type Notification, UserRole} from "@/models";


class Auth {

  dialog = ref<boolean>(false)
  loading = ref<boolean>(false)
  email = ref<string>('')
  password = ref<string>('')

  user = ref<User|undefined>()
  pendingPath = ref<string|undefined>()
  notifications = ref<Notification[]>([])
  private intv: number = -1


  async refreshNotifications(): Promise<void> {
    if(!this.isLoggedIn.value) return;
    let res = await api.listNoPagination<Notification>('notifications')
    if(res.success) {
      this.notifications.value = res.data ?? [];
    }
  }

  async refreshToken(): Promise<void> {
    if (!localStorage.token) {
      this.logout();
      return;
    }
    clearTimeout(this.intv)
    let res = await api.heartbeat()
    if (res.success) {
      localStorage.token = res.token;
      this.user.value = res.user!;
      await this.refreshNotifications()
      this.intv = window.setTimeout(async ()=>{
        await this.refreshToken()
      }, 60000)
    } else {
      this.logout();
    }
  }

  async setNotificationRead(id:string) {
    await api.get('notifications', id)
    await this.refreshNotifications()
  }

  async resetPassword(email: string): Promise<DocReply<any>> {
    return await api.resetPassword(email);
  }
  async login(): Promise<string | undefined> {
    this.loading.value = true;
    let res = await api.login(this.email.value, this.password.value)
    console.log("login res:", res)
    this.loading.value = false;
    if (!res.success) {
      return res.message;
    }

    if(!res.user) {
      return "email o password invalide"
    }

    this.user.value = res.user

    if(!this.isUser.value) {
      this.user.value = undefined
      return "non hai i permessi per accedere a questo pannello"
    }

    console.log("user:", this.user.value, res.token)
    localStorage.token = res.token
    this.intv = window.setTimeout(async ()=>{
      await this.refreshToken()
    }, 60000)
    this.dialog.value = false;
    return undefined
  }

  logout() {
    localStorage.removeItem('token')
    this.user.value = undefined;
    clearTimeout(this.intv);

    this.dialog.value = true;
  }

  public get waitForLogin(): Promise<boolean> {
    return new Promise((res) => {
      if (!localStorage.token) {
        res(false);
        return;
      }
      if (localStorage.token && this.user.value) {
        res(true);
        return;
      }
      let loop = setInterval(() => {
        if (!localStorage.token) {
          res(false);
          clearInterval(loop);
          return;
        }
        if (localStorage.token && this.user.value) {
          res(true);
          clearInterval(loop);
        }
      }, 250);
    })
  }

  isLoggedIn = computed<boolean>(() => {
    return !!this.user.value;
  })


  roleValue = computed<number>(() => {
    return this.user.value ? this.getRoleValue(this.user.value.role) : 0
  })

  getRoleValue(role: UserRole): number {
    switch (role) {
      case UserRole.root:
        return 100;
      case UserRole.admin:
        return 90;
      case UserRole.editor:
        return 50;
      case UserRole.viewer:
        return 30;
      case UserRole.user:
        return 10;
      default:
        return 0;
    }
  }



  isRoot = computed<boolean>(() => {
    return !!this.user.value && this.user.value.role === UserRole.root;
  })
  isAdmin = computed<boolean>(() => {
    return this.roleValue.value >= this.getRoleValue(UserRole.admin);
  })
  /** TODO: AGGIORNARE IN BASE AL NEGOZIO **/

  isEditor = computed<boolean>(() => {
    return this.roleValue.value >= this.getRoleValue(UserRole.editor)
  })

  isUser = computed<boolean>(() => {
    return this.roleValue.value >= this.getRoleValue(UserRole.user);
  })

  role = computed<UserRole>(() => {
    return this.user.value ? this.user.value.role : UserRole.guest;
  })

  userId = computed<string>((): string => {
    return this.user.value?._id ?? '';
  })
}


export default {
  install: (app: App) => {

    const auth = new Auth()

    app.provide<Auth>('auth', auth)
  },
};

export {Auth}
